import React from 'react';
import PropTypes from 'prop-types';

import { trackThenNavigate } from '../utils/adjustSdk';
import { placementForCtaLocation } from '../utils/adjust-page-tag';
import {
  CTA_DESTINATION,
  trackAppStoreClick,
  trackRegisterCtaClick
} from '../utils/register-cta-tracking';

function shouldHandleTrackedClick(event) {
  return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
}

function AdjustTrackedLink({
  href,
  appKind = null,
  target = '_self',
  rel,
  onClick,
  callbackParams = [],
  ctaLocation = null,
  children,
  ...props
}) {
  const safeRel = target === '_blank' ? rel || 'noopener noreferrer' : rel;

  const handleClick = async (event) => {
    onClick?.(event);

    if (event.defaultPrevented || !href || href === '#' || !shouldHandleTrackedClick(event)) {
      return;
    }

    event.preventDefault();

    // SEOENG-56: a tracked link that IS an acquisition CTA (a labelled hero slide, the mobile
    // download bar) registers as one; every tracked link registers the store click.
    if (ctaLocation) {
      trackRegisterCtaClick({
        product: appKind,
        ctaLocation,
        destination: CTA_DESTINATION.STORE_REDIRECT,
        link: href
      });
    }
    trackAppStoreClick({ product: appKind, ctaLocation, link: href });

    await trackThenNavigate({
      url: href,
      appKind,
      openInNewTab: target === '_blank',
      callbackParams,
      placement: placementForCtaLocation(ctaLocation)
    });
  };

  return (
    <a href={href} target={target} rel={safeRel} onClick={handleClick} {...props}>
      {children}
    </a>
  );
}

AdjustTrackedLink.propTypes = {
  appKind: PropTypes.oneOf(['gtg', 'gti']),
  callbackParams: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ),
  children: PropTypes.node.isRequired,
  ctaLocation: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  rel: PropTypes.string,
  target: PropTypes.string
};

export default AdjustTrackedLink;
